export const defaultValue = {
    id: '',
    company: '',
    roleName: '',
    description: '',
    active: true,
    permissions: [],
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
};
